import { Component, ContentChild, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { ImageUploadService } from '@shared/modules/image-upload/services/image-upload.service';
import {
  ImageDefaultValue,
  ImageFit,
  ImageGalleryItem,
  ImageUploadDirectory,
  ImageUrlSource,
} from '@shared/modules/image-upload/models/image-upload.models';
import { LifecycleHooks } from '@shared/services/lifecycle-hooks.service';
import { ImageUploadDefaultDirective } from '@shared/modules/image-upload/directive/image-upload-default.directive';
import { FileUploadMode, FileUploadShape, FileUploadSize } from '@shared/modules/file-upload/file-upload.models';

@Component({
  selector: 'zef-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss'],
  providers: [{ provide: ImageUploadService, useExisting: ImageUploadComponent }, LifecycleHooks],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ImageUploadComponent extends ImageUploadService {
  @Input()
  mode: FileUploadMode = 'image';

  @Input()
  size: FileUploadSize = 'medium';

  @Input()
  fit: ImageFit = 'contain';

  @Input()
  shape: FileUploadShape;

  @Input()
  directory: ImageUploadDirectory;

  @Input()
  source: string = ImageDefaultValue;

  @Input()
  gallery: boolean = false;

  @Input()
  color?: string;

  @Input()
  placeholder: string = '';

  @Input()
  customGallery?: boolean;

  @Input()
  disableClick?: boolean;

  @Input()
  urlSource: ImageUrlSource = 'regular';

  @ContentChild(ImageUploadDefaultDirective, { static: true })
  defaultDirective?: ImageUploadDefaultDirective;

  @Output()
  readonly sourceChange = new EventEmitter<{ image: ImageGalleryItem; source: string } | null>();
}
